import { Camera, FileText, Image, Link2, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function QuickAdd({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  if (!open) return null;
  const go = (mode: string) => { onClose(); navigate(`/dodaj?mode=${mode}`); };
  return <div className="modal-backdrop" onMouseDown={onClose}>
    <section className="quick-add" onMouseDown={event => event.stopPropagation()}>
      <div className="drawer-handle" />
      <div className="drawer-title"><div><h2>Dodaj ofertę</h2><p>AI uporządkuje dane i sprawdzi duplikaty</p></div><button onClick={onClose}><X /></button></div>
      <div className="quick-grid">
        <button onClick={() => go('link')}><span className="icon-blue"><Link2 /></span><strong>Wklej link</strong><small>Z dowolnego portalu</small></button>
        <button onClick={() => go('photos')}><span className="icon-green"><Image /></span><strong>Dodaj screeny</strong><small>Jedno lub wiele zdjęć</small></button>
        <button onClick={() => go('camera')}><span className="icon-orange"><Camera /></span><strong>Zrób zdjęcie</strong><small>Aparat telefonu</small></button>
        <button onClick={() => go('note')}><span className="icon-purple"><FileText /></span><strong>Wklej tekst</strong><small>Opis lub notatka</small></button>
      </div>
      <button className="manual-link" onClick={() => go('manual')}>Utwórz ręcznie</button>
    </section>
  </div>;
}
